var $e7129d65f607f77f$exports = {};
$e7129d65f607f77f$exports = {
  "decrease": function decrease(args) {
    return "V\xE4henn\xE4 ".concat(args.fieldLabel);
  },
  "increase": function increase(args) {
    return "Lis\xE4\xE4 ".concat(args.fieldLabel);
  },
  "numberField": "Numerokentt\xE4"
};
export { $e7129d65f607f77f$exports as default };